import { DriverDataFieldName } from "@app/pages/driver-data/driver-data.constant";
import { CommonEditContext, CommonSearchContext, CommonSearchCriteria, CommonSearchCriteriaModel, GenerateDefaultCommonSearchCriteria } from "./common-data.model";
import { Status } from "@shared/enums";

export const DefaultDriverData = {
  search: {
    searchForm: {
      model: {
        searchCriteria: [
          {
            searchBy: DriverDataFieldName.status,
            searchValue: [Status.ACTIVE],
            searchValueStart: '',
            searchValueEnd: ''
          } as CommonSearchCriteria,
          GenerateDefaultCommonSearchCriteria()
        ]
      } as CommonSearchCriteriaModel,
      dirty: false,
      status: null as any,
      errors: null as any,
    }
  } as CommonSearchContext,
  edit: {
    editForm: {
      model: {} as DriverDataEditCriteria,
      dirty: false,
      status: null as any,
      errors: null as any
    },
  } as CommonEditContext<DriverDataEditCriteria>,
}

export interface DriverDataEditCriteria {
  driver_Id: number;
  terminal_Id: number;
}
